import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/ServicesPage.css';
import Breadcrumbs from '../components/Breadcrumbs';
import { FaGuitar, FaMicrophoneAlt, FaCogs } from 'react-icons/fa';

const services = [
  {
    title: 'Lessons & Education',
    description: 'Private In-Home and Studio lessons for all skill levels.',
    link: '/services/lessons',
    icon: <FaGuitar className='service-icon' />
  },
  {
    title: 'Studio & Production',
    description: 'Audio/Video Recording & Image Design.',
    link: '/services/studio',
    icon: <FaCogs className='service-icon' />
  },
  {
    title: 'Live Sound & Events',
    description: 'PA System Rentals and Live Sound Engineering.',
    link: '/services/live-sound',
    icon: <FaMicrophoneAlt className='service-icon' />
  }
];

const ServicesOverview = () => {
  return (
    <div className='container services-overview'>
      <Breadcrumbs />
      <h1 className='text-center my-4'>Our Services</h1>
      <div className='row'>
        {services.map((service, index) => (
          <div key={index} className='col-md-4 d-flex align-items-stretch'>
            <div className='card service-card text-center'>
              <div className='card-body d-flex flex-column justify-content-center'>
                {service.icon}
                <h5 className='card-title mt-3'>{service.title}</h5>
                <p className='card-text'>{service.description}</p>
                <Link to={service.link} className='btn btn-outline-primary mt-auto'>Learn More</Link>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ServicesOverview;
